module.exports = __webpack_public_path__ + "img/pictures-at-an-exhibition-reimagined.715520ce.png";